import { formatItem, formatTypes, getFormattedDate } from 'global/common/dateFormatting'
import { gEnums } from 'global/enums/globalEnums'
import MotionWrapper from 'global/motions/MotionWrapper'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import { SectionSchedule } from '../matches/SectionSchedule'
import { LevelHeader } from './SectionHeader'

const _applyTestDate = false
const _selectedDate = '09/04/2025'

export const Scoreboard = () => {

  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state } = sportsSeasonContext ?? {};
  const { matches_info } = sportsSeason_state ?? {};
  const { matches_groupInfo } = matches_info ?? {};
  const { scheduleLevelKeys, levelSectionDateMatches } = matches_groupInfo ?? {};

  const [selectedDate, setSelectedDate] = useState()
  const [scoreboardDate, setScoreboardDate] = useState(_applyTestDate ? _selectedDate : selectedDate)

  useEffect(() => {
    const _dateFormatted = getFormattedDate(new Date())
    setSelectedDate(_dateFormatted)
    setScoreboardDate(_dateFormatted)
  }, []);

  const msdts = gEnums.matchScheduleDisplayTypes
  const props = { matchScheduleDisplayType: msdts.scoreboard }

  const _dateCaption = formatItem(formatTypes.fullDate, scoreboardDate)

  const handleDateClick = (forward) => {

    if (!scoreboardDate) return;

    const [month, day, year] = scoreboardDate.split('/').map(Number);
    const currentDate = new Date(year, month - 1, day);

    currentDate.setDate(currentDate.getDate() + (forward ? 1 : -1));

    const _newDate = currentDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    // setShowMissingMatches(false)

    if (_newDate) {
      setScoreboardDate(_newDate);
    }
  };

  const handleTodayClick = () => setScoreboardDate(getFormattedDate(new Date()))

  const topDatesHeader = useMemo(() => {
    return <div className='date-header'>
      <div><Icon name='arrow left' onClick={() => { handleDateClick(false) }} /></div>
      <div>{_dateCaption}</div>
      <div>
        <Icon name='calendar check outline' onClick={() => { handleTodayClick(true) }} />
        <Icon name='arrow right' onClick={() => { handleDateClick(true) }} />
      </div>
    </div>
  }, [_dateCaption])

  const levelDateMatches = (levelKey, matchesBySection) => {
    if (matchesBySection) {
      const sms = _.map(matchesBySection, (sectionMatches, sectionKey) => {
        return <SectionSchedule
          dateKey={scoreboardDate}
          levelKey={levelKey}
          sectionKey={sectionKey}
          matches_sections={sectionMatches}
        />
      })
      return sms
    }
    return <div style={{ padding: '1em' }}>No Matches</div>
  }

  const scoreboard = useMemo(() => {
    const scoreboards = _.map(scheduleLevelKeys, levelKey => {
      const _lsdm = levelSectionDateMatches?.[levelKey]
      const matchesBySection = _lsdm?.[scoreboardDate]
      const levelHeader = <LevelHeader levelKey={levelKey} />
      return <div className='scoreboard'>
        {levelHeader}
        {levelDateMatches(levelKey, matchesBySection)}
      </div>
    })
    return scoreboards
  }, [scheduleLevelKeys, levelSectionDateMatches, scoreboardDate])

  return <Wrapper
    header={topDatesHeader}
    content={<MotionWrapper wrapperKey={`scoreboard-${selectedDate}`}>
      <div className='scoreboard'>
        {scoreboard}
      </div>
    </MotionWrapper>}
    wrapperType={wrapperTypes.paddedHeader}
  ></Wrapper>

}
